// Port of api/fuel/app/classes/filter/search/games/filters/query/play/reports/text.php
import Util from 'offline/util'
export default {
	name: 'play.reports.text',
	priority: 66,
	require: function(config, filter) { return filter.play && filter.play.reports && filter.play.reports.text },
	run: function(config, filter, data, query) {
		var text = filter.play.reports.text.toLowerCase()
		query.where('p.play_comment', 'like', '%' + text + '%')
	}
}
